var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1751 5.73083C8.17331 5.73083 5.73083 8.17331 5.73083 11.1751C5.73083 14.1769 8.17331 16.6194 11.1751 16.6194C14.1769 16.6194 16.6194 14.1769 16.6194 11.1751C16.6194 8.17331 14.1769 5.73083 11.1751 5.73083ZM11.1751 14.9002C9.12119 14.9002 7.45008 13.229 7.45008 11.1751C7.45008 9.12119 9.12119 7.45008 11.1751 7.45008C13.229 7.45008 14.9002 9.12119 14.9002 11.1751C14.9002 13.229 13.229 14.9002 11.1751 14.9002ZM11.1751 0C5.01333 0 0 5.01333 0 11.1751C0 19.6367 10.1516 29.3545 10.5837 29.7642C10.7434 29.9156 10.9551 30 11.1751 30C11.3952 30 11.6068 29.9156 11.7665 29.7642C12.1986 29.3545 22.3502 19.6361 22.3502 11.1751C22.3502 5.01333 17.3369 0 11.1751 0ZM11.1751 27.9275C9.01918 25.7286 1.71925 17.7902 1.71925 11.1751C1.71925 5.96121 5.96121 1.71925 11.1751 1.71925C16.389 1.71925 20.631 5.96121 20.631 11.1751C20.631 17.7902 13.3311 25.7286 11.1751 27.9275Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSvg);
export default __webpack_public_path__ + "static/media/location-svg.5b7324336aabb88bdd13b48e2fc0aa7b.svg";
export { ForwardRef as ReactComponent };